import { docReady } from '../helpers/docReady';
import '../../styles/templates/blog.scss';
docReady(() => {
    // console.log('Blog Template JS Ready');
});
